import { useAuth } from "#/feature/auth/auth-context";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Redirects to `/login` when unauthenticated, or `/` when `admin` is required and the
 * user is not an admin. Returns whether the page may render (flash on redirect is OK).
 */
export function useRequireAuth(options?: { admin?: boolean }): boolean {
  const { isAuthenticated, isLoading, connectionError, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const admin = options?.admin === true;

  useEffect(() => {
    if (isLoading || connectionError) return;
    if (!isAuthenticated) {
      void navigate("/login", { replace: true, state: { from: location } });
      return;
    }
    if (admin && user?.role !== "admin") {
      void navigate("/", { replace: true });
    }
  }, [isLoading, connectionError, isAuthenticated, user, admin, navigate, location]);

  if (isLoading || connectionError) return false;
  if (!isAuthenticated) return false;
  if (admin && user?.role !== "admin") return false;
  return true;
}
